import { useMemo } from 'react';
import { getNodes, useGetNodes } from '@kinetic-ui/shared';
import { filterEvents } from 'kinetictils';
import {
  useEventManagementQuery,
  useEventTemplatesQuery,
  useResourcePlanListQuery,
} from '@kinetic-ui/data-layer';

export const useCombinedResults = (searchText: string, isAppSearch: boolean) => {
  const { data } = useEventManagementQuery({
    variables: {
      filters: filterEvents(),
      searchText,
      limit: 5,
    },
  });

  const { data: templateData } = useEventTemplatesQuery({
    variables: {
      filters: filterEvents(),
      searchText,
      limit: 5,
    },
  });

  const { data: resourcePlanData } = useResourcePlanListQuery({
    variables: {
      filters: filterEvents(),
      searchText,
      limit: 5,
    },
  });

  const events = useGetNodes(data?.events);
  const templates = useGetNodes(templateData?.eventTemplates);
  const normalizedTemplates = useMemo(
    () =>
      templates.map((template) => ({
        ...template,
        geometry: template.template?.geometry,
        category: template.template?.category,
      })),
    [templates]
  );
  const resourcePlans = useMemo(
    () => getNodes(resourcePlanData?.resourcePlans),
    [resourcePlanData]
  );
  const normalizedResourcePlans = useMemo(
    () =>
      resourcePlans.map((resourcePlan) => ({
        ...resourcePlan,
        name: resourcePlan.details?.name,
        category: null,
        geometry: null,
      })),
    [resourcePlans]
  );

  const combinedResults = useMemo(() => {
    if (isAppSearch) {
      return [...events, ...normalizedTemplates, ...normalizedResourcePlans];
    }
    return events;
  }, [isAppSearch, events, normalizedTemplates, normalizedResourcePlans]);

  return combinedResults;
};
